import type { GapsSummary } from '../../types';

interface GapSectionChartProps {
  sections: GapsSummary['by_section'];
}

export function GapSectionChart({ sections }: GapSectionChartProps) {
  const maxCount = Math.max(...sections.map(s => s.count), 1);

  return (
    <div className="space-y-3">
      <h3 className="text-sm font-medium text-wolf-300">Gaps by Section</h3>
      {sections.length === 0 ? (
        <p className="text-wolf-500 text-sm">No gap data available</p>
      ) : (
        <div className="space-y-2">
          {sections.map((section) => {
            const width = (section.count / maxCount) * 100;
            return (
              <div key={section.section_id}>
                <div className="flex justify-between text-sm mb-1">
                  <span className="text-wolf-300">{section.section_name}</span>
                  <span className="text-wolf-400 font-mono">
                    {section.count} ({section.pct}%)
                  </span>
                </div>
                <div className="h-2 bg-wolf-800 border border-wolf-700 rounded overflow-hidden">
                  <div
                    className="h-full bg-action transition-all duration-500"
                    style={{ width: `${width}%` }}
                  />
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
